<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/calendar.jpg');
            background-position: top !important;
          "
        ></div>
        <!-- <img src="/static/img/video-main-banner.svg" /> -->
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">
              {{ $t("schedule overview") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div id="weekviewcontainer" v-bind:class="{ weekSticky: isSticky }">
      <img
        src="../assets/img/slide.svg"
        class="scroll-icon"
        alt="Scrolling Icon"
        width="30"
      />
      <div class="d-flex justify-end justify-between">
        <div class="toggleWrap">
          <router-link
            to="/calendar"
            tag="button"
            class="savebutton v-btn v-size--default switchBtn activeBtn"
          >
            <img src="../assets/img/arrow_right.png" alt="Icon" />
            {{ $t("default_view") }}
          </router-link>
          <router-link
            to="/sales-calendar"
            tag="button"
            class="savebutton v-btn v-size--default switchBtn"
          >
            <img src="../assets/img/arrow_right.png" alt="Icon" />
            {{ $t("sales_calendar") }}
          </router-link>
        </div>
        <v-btn
          :href="`/api/calendar/export/` + selectedYear"
          v-show="$rights.includes('DOWNLOAD_CALENDER_CSV')"
          outlined
          depressed
          tile
          class="savebutton mb-2 ml-5 relativeBtn"
          >{{ $t("export_csv") }}</v-btn
        >
      </div>
      <div
        class="weekviewcontainerWrap"
        v-bind:class="{ stickyFilter: isSticky }"
      >
        <div id="grouphead" v-bind:class="{ stickyFilter: isSticky }">
          <div class="left-group">
            <button class="today_btn" @click="todayClick()">
              {{ $t("today") }}
            </button>
            <button
              class="btn btn-info btn-arrow wpreviousBtn"
              @click="prevWeek()"
              id="prevClick"
              title="Previous Year"
            >
              <v-icon>fa-solid fa-chevron-left</v-icon>
            </button>
            <button
              class="btn btn-info btn-arrow wnextBtn"
              @click="nextWeek()"
              id="nextClick"
              title="Next Year"
            >
              <v-icon>fa-solid fa-chevron-right</v-icon>
            </button>
            <div id="weekDisplay" v-bind:title="weekDisplay">
              {{ weekDisplay }}
            </div>
          </div>
          <div class="right-group">
            <div class="custom-select-dropdown custom-years-dropdown">
              <v-autocomplete
                v-model="yearFilter"
                hide-details="auto"
                class="justify-content-end searchbar align-self-center"
                :items="yearsList"
                item-text="name"
                item-value="id"
                dense
                outlined
                :label="$t('select_year')"
                @change="changeYear()"
              >
                <template v-slot:append></template>
              </v-autocomplete>
            </div>
            <div class="custom-select-dropdown custom-month-dropdown">
              <v-autocomplete
                v-model="monthFilter"
                hide-details="auto"
                class="justify-content-end searchbar align-self-center"
                :items="monthsList"
                item-text="name"
                item-value="id"
                dense
                outlined
                :label="$t('select_month')"
                @change="changeMonth()"
              >
                <template v-slot:append></template>
              </v-autocomplete>
            </div>
            <div class="custom-select-dropdown custom-location-dropdown">
              <v-autocomplete
                v-model="locationFilter"
                hide-details="auto"
                class="justify-content-end searchbar align-self-center"
                :items="locationsList"
                item-text="name"
                item-value="id"
                dense
                outlined
                :label="$t('viewAllTrainerLocation')"
              >
                <template v-slot:append></template>
              </v-autocomplete>
            </div>
            <div class="custom-select-dropdown custom-location-dropdown">
              <v-autocomplete
                v-model="roomlocationFilter"
                hide-details="auto"
                class="justify-content-end searchbar align-self-center"
                :items="roomslocationsList"
                item-text="name"
                item-value="id"
                dense
                outlined
                :label="$t('viewAllRoomLocation')"
              >
                <template v-slot:append></template>
              </v-autocomplete>
            </div>
            <div class="custom-select-dropdown custom-trainers-dropdown">
              <v-autocomplete
                v-model="trainersFilter"
                hide-details="auto"
                class="justify-content-end searchbar align-self-center"
                :items="trainersList"
                item-text="name"
                item-value="id"
                dense
                outlined
                :label="$t('viewAllTrainers')"
                @change="changeTrainerType()"
              >
                <template v-slot:append></template>
              </v-autocomplete>
            </div>
          </div>
        </div>
        <div class="t-wrapper">
          <table>
            <thead>
              <tr class="weekhead">
                <th>{{ $t("date") }}</th>
                <th
                  class="title"
                  data-name="Mon"
                  v-bind:data-value="mondayDate"
                  v-bind:class="{
                    'bg-blue':
                      monday.slice(3) == this.currentDay &&
                      parseInt(mondayDate.split('-')[1], 10) == this.monthToday,
                  }"
                >
                  {{ monday }}
                </th>
                <th
                  class="title"
                  data-name="Tue"
                  v-bind:data-value="tuesdayDate"
                  v-bind:class="{
                    'bg-blue':
                      tuesday.slice(3) == this.currentDay &&
                      parseInt(tuesdayDate.split('-')[1], 10) ==
                        this.monthToday,
                  }"
                >
                  {{ tuesday }}
                </th>
                <th
                  class="title"
                  data-name="Wed"
                  v-bind:data-value="wednesdayDate"
                  v-bind:class="{
                    'bg-blue':
                      wednesday.slice(3) == this.currentDay &&
                      parseInt(wednesdayDate.split('-')[1], 10) ==
                        this.monthToday,
                  }"
                >
                  {{ wednesday }}
                </th>
                <th
                  class="title"
                  data-name="Thu"
                  v-bind:data-value="thursdayDate"
                  v-bind:class="{
                    'bg-blue':
                      thursday.slice(3) == this.currentDay &&
                      parseInt(thursdayDate.split('-')[1], 10) ==
                        this.monthToday,
                  }"
                >
                  {{ thursday }}
                </th>
                <th
                  class="title"
                  data-name="Fri"
                  v-bind:data-value="fridayDate"
                  v-bind:class="{
                    'bg-blue':
                      friday.slice(3) == this.currentDay &&
                      parseInt(fridayDate.split('-')[1], 10) == this.monthToday,
                  }"
                >
                  {{ friday }}
                </th>
                <th
                  class="title redColor"
                  data-name="Sat"
                  v-bind:data-value="saturdayDate"
                  v-bind:class="{
                    'bg-blue':
                      saturday.slice(3) == this.currentDay &&
                      parseInt(saturdayDate.split('-')[1], 10) ==
                        this.monthToday,
                  }"
                >
                  {{ saturday }}
                </th>
                <th
                  class="title redColor"
                  data-name="Sun"
                  v-bind:data-value="sundayDate"
                  v-bind:class="{
                    'bg-blue':
                      sunday.slice(3) == this.currentDay &&
                      parseInt(sundayDate.split('-')[1], 10) == this.monthToday,
                  }"
                >
                  {{ sunday }}
                </th>
              </tr>
              <tr>
                <th></th>
                <th
                  class="one"
                  data-week="0"
                  data-name="Mon"
                  v-bind:class="{
                    'bg-blue':
                      monday.slice(3) == this.currentDay &&
                      parseInt(mondayDate.split('-')[1], 10) == this.monthToday,
                  }"
                >
                  {{ $t("monday") }}
                </th>
                <th
                  class="one"
                  data-week="0"
                  data-name="Tue"
                  v-bind:class="{
                    'bg-blue':
                      tuesday.slice(3) == this.currentDay &&
                      parseInt(tuesdayDate.split('-')[1], 10) ==
                        this.monthToday,
                  }"
                >
                  {{ $t("tuesday") }}
                </th>
                <th
                  class="one"
                  data-week="0"
                  data-name="Wed"
                  v-bind:class="{
                    'bg-blue':
                      wednesday.slice(3) == this.currentDay &&
                      parseInt(wednesdayDate.split('-')[1], 10) ==
                        this.monthToday,
                  }"
                >
                  {{ $t("wednesday") }}
                </th>
                <th
                  class="one"
                  data-week="0"
                  data-name="Thu"
                  v-bind:class="{
                    'bg-blue':
                      thursday.slice(3) == this.currentDay &&
                      parseInt(thursdayDate.split('-')[1], 10) ==
                        this.monthToday,
                  }"
                >
                  {{ $t("thursday") }}
                </th>
                <th
                  class="one"
                  data-week="0"
                  data-name="Fri"
                  v-bind:class="{
                    'bg-blue':
                      friday.slice(3) == this.currentDay &&
                      parseInt(fridayDate.split('-')[1], 10) == this.monthToday,
                  }"
                >
                  {{ $t("friday") }}
                </th>
                <th
                  class="one redColor"
                  data-week="0"
                  data-name="Sat"
                  v-bind:class="{
                    'bg-blue':
                      saturday.slice(3) == this.currentDay &&
                      parseInt(saturdayDate.split('-')[1], 10) ==
                        this.monthToday,
                  }"
                >
                  {{ $t("saturday") }}
                </th>
                <th
                  class="one redColor"
                  data-week="0"
                  data-name="Sun"
                  v-bind:class="{
                    'bg-blue':
                      sunday.slice(3) == this.currentDay &&
                      parseInt(sundayDate.split('-')[1], 10) == this.monthToday,
                  }"
                >
                  {{ $t("sunday") }}
                </th>
              </tr>
              <tr>
                <th>{{ $t("KW") }}</th>
                <th
                  id="weekNumber"
                  v-bind:title="weekNumber"
                  v-bind:class="{
                    'bg-blue':
                      monday.slice(3) == this.currentDay &&
                      parseInt(mondayDate.split('-')[1], 10) == this.monthToday,
                  }"
                >
                  {{ weekNumber }}
                </th>
                <th
                  v-bind:class="{
                    'bg-blue':
                      tuesday.slice(3) == this.currentDay &&
                      parseInt(tuesdayDate.split('-')[1], 10) ==
                        this.monthToday,
                  }"
                ></th>
                <th
                  v-bind:class="{
                    'bg-blue':
                      wednesday.slice(3) == this.currentDay &&
                      parseInt(wednesdayDate.split('-')[1], 10) ==
                        this.monthToday,
                  }"
                ></th>
                <th
                  v-bind:class="{
                    'bg-blue':
                      thursday.slice(3) == this.currentDay &&
                      parseInt(thursdayDate.split('-')[1], 10) ==
                        this.monthToday,
                  }"
                ></th>
                <th
                  v-bind:class="{
                    'bg-blue':
                      friday.slice(3) == this.currentDay &&
                      parseInt(fridayDate.split('-')[1], 10) == this.monthToday,
                  }"
                ></th>
                <th
                  v-bind:class="{
                    'bg-blue':
                      saturday.slice(3) == this.currentDay &&
                      parseInt(saturdayDate.split('-')[1], 10) ==
                        this.monthToday,
                  }"
                ></th>
                <th
                  v-bind:class="{
                    'bg-blue':
                      sunday.slice(3) == this.currentDay &&
                      parseInt(sundayDate.split('-')[1], 10) == this.monthToday,
                  }"
                ></th>
              </tr>
            </thead>
            <tbody
              v-bind:class="locationFilter"
              v-bind:id="trainersFilterEdited"
            >
              <tr
                class="calendar-content-row location trainerType"
                v-for="(
                  trainerAppointment, itemIndex
                ) in allObjectsMonth.trainerAppointments"
                v-bind:class="trainerAppointment.trainerType"
                v-if="
                  locationFilter === 'View all Trainer locations' ||
                  (locationFilter === trainerAppointment.trainerLocation &&
                    locationFilter !== 'View all Trainer locations')
                "
              >
                <td>
                  <div class="bg-beige">
                    <p class="trainerName">
                      <img
                        class="trainerTypeImg"
                        src="../assets/img/trainer-icon.svg"
                      />
                      {{ trainerAppointment.fullname }}
                    </p>
                    <p
                      class="trainerTypeName"
                      v-if="trainerAppointment.trainerType === 'fullTime'"
                    >
                      <span>
                        <img
                          class="trainerTypeImg"
                          src="/static/img/fulltime@2x.png"
                        />
                      </span>
                      {{ $t("full_time") }}
                    </p>
                    <p
                      class="trainerTypeName trainerPartTypeName"
                      v-if="trainerAppointment.trainerType === 'partTime'"
                    >
                      <span>
                        <img
                          class="trainerTypeImg"
                          src="/static/img/parttime@2x.png"
                        />
                      </span>
                      {{ $t("part_time") }}
                    </p>
                    <p class="trainerLoc">
                      <v-icon>fas fa-map-marker-alt</v-icon>
                      {{
                        trainerAppointment.trainerLocation
                          ? $t(trainerAppointment.trainerLocation)
                          : ""
                      }}
                    </p>
                  </div>
                </td>

                <td
                  v-for="dayData in daysOfWeek"
                  class="bg-beige calendar-day"
                  @click.stop="
                    calendarDayClicked(
                      trainerAppointment.trainer,
                      dayData.day,
                      dayData.monthCount,
                      'TRAINER'
                    )
                  "
                >
                  <div
                    v-for="(
                      trainerAppointment, index
                    ) in allObjectsMonthPrev.trainerAppointments"
                    v-if="itemIndex == index"
                  >
                    <div
                      v-for="(
                        day, index
                      ) in trainerAppointment.daysWithAppointments"
                      :set="(appointmentOnDay = day.appointment)"
                      :data-id="index + 1"
                      @click.stop="
                        calendarDayClicked(
                          trainerAppointment.trainer,
                          dayData.day,
                          dayData.monthCount,
                          'TRAINER',
                          day.appointment
                        )
                      "
                    >
                      <div
                        v-if="appointmentOnDay != null"
                        v-bind:data-date="
                          appointmentOnDay.start.slice(0, 8) + (index + 1)
                        "
                        :set="
                          (appointmentDate =
                            appointmentOnDay.start.slice(0, 8) + (index + 1))
                        "
                      >
                        <div
                          class="checkItem"
                          v-if="dayData.date == appointmentDate"
                        >
                          <appointment-card
                            v-for="type in appointmentType"
                            :appointment="appointmentOnDay"
                            :color-class="getColorClass(type)"
                            :appointment-type="type"
                            :day="day"
                            :trainer-appointment="trainerAppointment"
                          />
                        </div>
                      </div>
                      <span v-else>&nbsp;</span>
                    </div>
                  </div>
                  <div class="currentMonthItem">
                    <div
                      v-for="(
                        day, index
                      ) in trainerAppointment.daysWithAppointments"
                      :set="(appointmentOnDay = day.appointment)"
                      :data-id="index + 1"
                      @click.stop="
                        calendarDayClicked(
                          trainerAppointment.trainer,
                          dayData.day,
                          dayData.monthCount,
                          'TRAINER',
                          day.appointment
                        )
                      "
                    >
                      <div
                        v-if="appointmentOnDay != null"
                        v-bind:data-date="day.date.slice(0, 8) + (index + 1)"
                        :set="
                          (appointmentDate = day.date.slice(0, 8) + (index + 1))
                        "
                      >
                        <div
                          class="checkItem"
                          v-if="dayData.date == appointmentDate"
                        >
                          <appointment-card
                            v-for="type in appointmentType"
                            :appointment="appointmentOnDay"
                            :color-class="getColorClass(type)"
                            :appointment-type="type"
                            :day="day"
                            :trainer-appointment="trainerAppointment"
                          />
                        </div>
                      </div>
                      <span v-else>&nbsp;</span>
                    </div>
                  </div>

                  <div
                    v-for="(
                      trainerAppointment, index
                    ) in allObjectsMonthNext.trainerAppointments"
                    v-if="itemIndex == index"
                  >
                    <div
                      v-for="(
                        day, index
                      ) in trainerAppointment.daysWithAppointments"
                      :set="(appointmentOnDay = day.appointment)"
                      :data-id="index + 1"
                      @click.stop="
                        calendarDayClicked(
                          trainerAppointment.trainer,
                          dayData.day,
                          dayData.monthCount,
                          'TRAINER',
                          day.appointment
                        )
                      "
                    >
                      <div
                        v-if="appointmentOnDay != null"
                        v-bind:data-date="
                          appointmentOnDay.end.slice(0, 8) + (index + 1)
                        "
                        :set="
                          (appointmentDate =
                            appointmentOnDay.end.slice(0, 8) + (index + 1))
                        "
                      >
                        <div
                          class="checkItem"
                          v-if="dayData.date == appointmentDate"
                        >
                          <appointment-card
                            v-for="type in appointmentType"
                            :appointment="appointmentOnDay"
                            :color-class="getColorClass(type)"
                            :appointment-type="type"
                            :day="day"
                            :trainer-appointment="trainerAppointment"
                          />
                        </div>
                      </div>
                      <span v-else>&nbsp;</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr
                class="calendar-content-row location"
                v-for="(
                  roomAppointment, itemIndex
                ) in allObjectsMonth.roomAppointments"
                :key="itemIndex"
                v-if="
                  roomlocationFilter === 'View all Room locations' ||
                  (roomlocationFilter === roomAppointment.roomLocation &&
                    roomlocationFilter !== 'View all Room locations')
                "
              >
                <td>
                  <div class="bg-beige">
                    <p class="trainerName">
                      <img
                        class="trainerTypeImg"
                        src="../assets/img/room-icon.svg"
                      />
                      {{ roomAppointment.room.designation }}
                    </p>
                    <p class="roomLoc">
                      <v-icon>fas fa-map-marker-alt</v-icon>
                      {{ $t(roomAppointment.roomLocation) }}
                    </p>
                  </div>
                </td>
                <td
                  class="bg-beige calendar-day"
                  :key="dayData.name + 'ROOM'"
                  v-for="dayData in daysOfWeek"
                  @click.stop="
                    calendarDayClicked(
                      roomAppointment.room.id,
                      dayData.day,
                      dayData.monthCount,
                      'ROOM'
                    )
                  "
                >
                  <div
                    v-for="(
                      roomAppointment, index
                    ) in allObjectsMonthPrev.roomAppointments"
                    v-if="itemIndex == index"
                    :key="index"
                  >
                    <div
                      v-for="(
                        day, index
                      ) in roomAppointment.daysWithAppointments"
                      :set="(appointmentOnDay = day.appointment)"
                      @click.stop="
                        calendarDayClicked(
                          roomAppointment.room.id,
                          dayData.day,
                          dayData.monthCount,
                          'ROOM',
                          day.appointment
                        )
                      "
                    >
                      <div
                        v-if="appointmentOnDay != null"
                        v-bind:data-date="
                          appointmentOnDay.start.slice(0, 8) + (index + 1)
                        "
                        :set="
                          (appointmentDate =
                            appointmentOnDay.start.slice(0, 8) + (index + 1))
                        "
                      >
                        <div
                          class="checkItem"
                          v-if="dayData.date == appointmentDate"
                        >
                          <room-appointment-card
                            :appointment="appointmentOnDay"
                            :color-class="'lightBlue_traning'"
                            :appointment-type="'ROOM_BLOCKED'"
                            :day="day"
                            :room-appointment="roomAppointment"
                          ></room-appointment-card>
                        </div>
                      </div>
                      <span v-else>&nbsp;</span>
                    </div>
                  </div>
                  <div class="currentMonthItem">
                    <div
                      v-for="(
                        day, index
                      ) in roomAppointment.daysWithAppointments"
                      :set="(appointmentOnDay = day.appointment)"
                      @click.stop="
                        calendarDayClicked(
                          roomAppointment.room.id,
                          dayData.day,
                          dayData.monthCount,
                          'ROOM',
                          day.appointment
                        )
                      "
                    >
                      <div
                        v-if="appointmentOnDay != null"
                        v-bind:data-date="day.date.slice(0, 8) + (index + 1)"
                        :set="
                          (appointmentDate = day.date.slice(0, 8) + (index + 1))
                        "
                      >
                        <div
                          class="checkItem"
                          v-if="dayData.date == appointmentDate"
                        >
                          <room-appointment-card
                            :appointment="appointmentOnDay"
                            :color-class="'lightBlue_traning'"
                            :appointment-type="'ROOM_BLOCKED'"
                            :day="day"
                            :room-appointment="roomAppointment"
                          ></room-appointment-card>
                        </div>
                      </div>
                      <span v-else>&nbsp;</span>
                    </div>
                  </div>
                  <div
                    v-for="(
                      roomAppointment, index
                    ) in allObjectsMonthNext.roomAppointments"
                    v-if="itemIndex == index"
                  >
                    <div
                      v-for="(
                        day, index
                      ) in roomAppointment.daysWithAppointments"
                      :set="(appointmentOnDay = day.appointment)"
                      :key="
                        dayData.date +
                        dayData.monthCount +
                        roomAppointment.room.id +
                        index
                      "
                      @click.stop="
                        calendarDayClicked(
                          roomAppointment.room.id,
                          dayData.day,
                          dayData.monthCount,
                          'ROOM',
                          day.appointment
                        )
                      "
                    >
                      <div
                        v-if="appointmentOnDay != null"
                        v-bind:data-date="
                          appointmentOnDay.end.slice(0, 8) + (index + 1)
                        "
                        :set="
                          (appointmentDate =
                            appointmentOnDay.end.slice(0, 8) + (index + 1))
                        "
                      >
                        <div
                          class="checkItem"
                          v-if="dayData.date == appointmentDate"
                        >
                          <room-appointment-card
                            :appointment="appointmentOnDay"
                            :color-class="'lightBlue_traning'"
                            :appointment-type="'ROOM_BLOCKED'"
                            :day="day"
                            :room-appointment="roomAppointment"
                          ></room-appointment-card>
                        </div>
                      </div>
                      <span v-else>&nbsp;</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <v-dialog v-model="openAddDialog">
          <div class="cal-app">
            <h3 v-show="appointment.id == null">{{ $t("add_appointment") }}</h3>
            <h3 v-show="appointment.id != null">
              {{ $t("edit_appointment") }}
            </h3>
            <br />
            <div class="row">
              <div class="col-sm-6 col-md-6">
                <DatePicker
                  v-model="appointment.start"
                  clearable
                  :label="$t('begin_date')"
                />
              </div>
              <div class="col-sm-6 col-md-6">
                <DatePicker
                  v-model="appointment.end"
                  clearable
                  :label="$t('end_date')"
                />
              </div>
              <div class="col-sm-12 col-md-12">
                <v-select
                  dense
                  outlined
                  class="datainput"
                  hide-details="auto"
                  :items="appointmentTypesUpdated"
                  item-text="text"
                  item-value="value"
                  :label="$t('type') + '*'"
                  v-model="appointment.type"
                  :disabled="dialog.type == 'ROOM'"
                ></v-select>
              </div>
              <div
                class="col-sm-12 col-md-12"
                v-show="dialog.type == 'TRAINER'"
              >
                <v-autocomplete
                  v-model="appointment.userReference"
                  hide-details="auto"
                  class="datainput justify-content-end searchbar align-self-center pb-1"
                  :items="trainers"
                  item-text="fullname"
                  item-value="id"
                  style="padding-right: 2px"
                  dense
                  outlined
                  :label="$t('user')"
                >
                </v-autocomplete>
              </div>
              <div class="col-sm-12 col-md-12">
                <v-textarea
                  hide-details="auto"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  :label="$t('description')"
                  v-model="appointment.description"
                  clearable
                ></v-textarea>
              </div>
              <div class="col-sm-12 col-md-12 pt-0">
                <v-checkbox
                  v-if="appointment.type == 'MISCELLANEOUS'"
                  v-model="appointment.productive"
                  class="no-margin-top"
                  :label="'Productive'"
                ></v-checkbox>
              </div>
            </div>
            <div class="text-center">
              <v-dialog v-model="openDeleteDialog" width="500">
                <h4>{{ $t("confirm_delete_Appoinment") }}</h4>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="openDeleteDialog = false"
                    outlined
                    depressed
                    tile
                    class="cancelBtn mr-2"
                  >
                    {{ $t("cancel") }}</v-btn
                  >
                  <v-btn
                    @click="deleteAppointment()"
                    outlined
                    depressed
                    tile
                    class="savebutton"
                  >
                    <v-icon color="#444">mdi-delete</v-icon>
                    {{ $t("delete") }}</v-btn
                  >
                </v-card-actions>
              </v-dialog>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                v-show="$rights.includes('CREATE_APPOINTMENT')"
                @click="saveAppointment()"
                outlined
                depressed
                tile
                class="savebutton"
                >{{ $t("save") }}</v-btn
              >
              <v-btn
                @click="openAddDialog = false"
                outlined
                depressed
                tile
                class="cancelBtn mr-2"
                >{{ $t("cancel") }}</v-btn
              >
              <v-btn
                @click="openDeleteDialog = true"
                v-show="
                  !appointment.clickable &&
                  appointment.id != null &&
                  $rights.includes('DELETE_APPOINTMENT')
                "
                outlined
                depressed
                tile
                class="deletebutton cancelBtn mr-2 mb-0"
                ><v-icon color="#444">mdi-delete</v-icon>
                {{ $t("delete") }}</v-btn
              >
            </v-card-actions>
          </div>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
var nd = new Date();
Date.prototype.GetFirstDayOfWeek = function () {
  return new Date(
    this.setDate(this.getDate() - this.getDay() + (this.getDay() == 0 ? -6 : 1))
  );
};
Date.prototype.getWeek = function () {
  var onejan = new Date(this.getFullYear(), 0, 1);
  return Math.ceil(((this - onejan) / 86400000 + onejan.getDay() + 1) / 7);
};
let nav = 0;
var wlnav = 0;
var ndate = nd.getDate();
var nday = nd.getDay();
var weekOfMonth = Math.ceil((ndate - 1 - nday) / 7);
nav = weekOfMonth;
var getweekdt = nd.GetFirstDayOfWeek();
const formatDate = new Intl.DateTimeFormat("en", {
  day: "2-digit",
  month: "2-digit",
});
const headwdate = new Intl.DateTimeFormat("en", {
  year: "numeric",
  month: "short",
  day: "numeric",
});
const headwdateFull = new Intl.DateTimeFormat("en-CA", {
  year: "numeric",
  month: "2-digit",
  day: "numeric",
});
const dt = new Date();
const fweekdt = headwdate.format(getweekdt.setDate(getweekdt.getDate()));
var fdaydt = fweekdt.split(" ")[1];
fdaydt = fdaydt.split(",")[0];
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      ModifyWeekNumber: false,
      weekNumberForStart: 1,
      totalWeeksInYear: 52,
      totalWeeksInLastYear: 52,
      ModifyWeek: false,
      openDeleteDialog: false,
      counter: 0,
      monthToday: new Date().getMonth() + 1,
      appointmentType: [
        "VACATION",
        "ABSENCE",
        "TRAINING_AS_TRAINER",
        "TRAINING_INITIATIVE",
        "TRAINING_DEVELOPMENT",
        "PREPARATION_TIME",
        "TRAVEL_TIME",
        "FURTHER_EDUCATION",
        "POSTPROCESSION_TIME",
        "SERVICE",
        "HOLIDAY",
        "MISCELLANEOUS",
        "ROOM_BLOCKED",
      ],
      days: [],
      trainerAppointments: [],
      roomAppointments: [],
      // monthNames: [
      //   "january",
      //   "february",
      //   "march",
      //   "april",
      //   "may",
      //   "june",
      //   "july",
      //   "august",
      //   "september",
      //   "october",
      //   "november",
      //   "december",
      // ],
      weekdays: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
      months: [],
      currentDay: null,
      currentMonth: null,
      selectedYear: null,
      dialog: {
        type: "TRAINER",
      },
      openAddDialog: false,
      trainers: [],
      yearFilter: [],
      // yearsList: [
      //   "Select Year",
      //   "2024",
      //   "2025",
      //   "2026",
      //   "2026",
      //   "2027",
      //   "2028",
      //   "2029",
      //   "2030",
      // ],
      monthFilter: [],
      // monthsList: [
      //   "Select Month",
      //   "January",
      //   "February",
      //   "March",
      //   "April",
      //   "May",
      //   "June",
      //   "July",
      //   "August",
      //   "September",
      //   "October",
      //   "November",
      //   "December",
      // ],
      locationFilter: [],
      locationsList: [],
      roomlocationFilter: [],
      roomslocationsList: [],
      trainersFilter: [],
      // trainersList: ["View all Trainers", "Full Time", "Part Time"],
      trainersFilterEdited: [],

      allObjects: [],

      appointmentTypes: [],

      appointment: {
        id: null,
        start: null,
        end: null,
        reference: null,
        userReference: null,
        description: null,
        productive: null,
      },

      weekNumber: null,
      monday: null,
      tuesday: null,
      wednesday: null,
      thursday: null,
      friday: null,
      saturday: null,
      sunday: null,

      mondayDate: null,
      tuesdayDate: null,
      wednesdayDate: null,
      thursdayDate: null,
      fridayDate: null,
      saturdayDate: null,
      sundayDate: null,
      weekDisplay: null,
      monthCount: null,
      yearCount: null,
      trainerIndex: null,
      allObjectsMonthPrev: [],
      allObjectsMonth: [],
      allObjectsMonthNext: [],
      nd: new Date(),
      fdweek: null,
      getweekdt: null,
      MondayDate: null,
      TuesdayDate: null,
      WednesdayDate: null,
      ThursdayDate: null,
      FridayDate: null,
      SatdayDate: null,
      SundayDate: null,

      MondayMonthCount: null,
      TuesdayMonthCount: null,
      WednesdayMonthCount: null,
      ThursdayMonthCount: null,
      FridayMonthCount: null,
      SaturdayMonthCount: null,
      SundayMonthCount: null,
      getMonthCount: null,
      spinner: null,

      startDate: null,
      weekNumDays: null,
      prevYear: null,
      nextYear: null,
      firstDayOfPrevYear: null,
      lastDayOfPrevYear: null,
      startOfWeekPrevYear: null,
      endOfWeekPrevYear: null,
      totalDays: null,
      totalWeeks: null,
      firstDayOfNextYear: null,
      lastDayOfNextYear: null,
      startOfWeekNextYear: null,
      endOfWeekNextYear: null,
      firstWeek: null,

      isSticky: false,
    };
  },
  beforeDestroy() {
    // Clean up event listener
    window.removeEventListener("storage", this.handleStorageChange);
  },

  mounted() {
    window.addEventListener("storage", this.handleStorageChange);
    this.currentDay = new Date().getDate();
    this.currentMonth = new Date().getMonth();
    this.selectedYear = new Date().getFullYear();
    this.totalWeeksInYear = this.getTotalWeeksInYear(this.selectedYear);
    this.totalWeeksInLastYear = this.getTotalWeeksInYear(this.selectedYear - 1);
    this.fetchAppointments(dt.getMonth() + 1);
    this.monthStore = dt.getMonth() + 1;
    this.fetchTrainers();
    this.fetchAppointmentTypes();
    window.addEventListener("scroll", this.handleScroll);
    this.locationFilter = "View all Trainer locations";
    this.roomlocationFilter = "View all Room locations";
    this.fdweek = this.nd.GetFirstDayOfWeek();
    this.getweekdt = this.nd.GetFirstDayOfWeek();
    for (let i = 0; i <= 13; i++) {
      this.allObjects.push({
        month: i,
        trainerAppointments: [],
        roomAppointments: [],
      });
    }
    //this.updateMonthlyObjects(dt.getMonth());

    this.prevYear = this.selectedYear - 1;
    this.nextYear = this.selectedYear + 1;
    this.startDate = new Date(this.nd.getFullYear(), 0, 1);
    this.weekNumber = this.getISOWeekNumber(this.fdweek);
    this.updateWeekDays(formatDate, headwdateFull);
    this.updateWeekDisplay(headwdate);
    this.updateWeekDates();
    this.monthCount = this.fdweek.getMonth();
    this.newYr = this.fdweek.getFullYear();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    yearsList() {
      return [
        this.$t("select_year"),
        "2024",
        "2025",
        "2026",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
      ];
    },

    appointmentTypesUpdated() {
      return this.appointmentTypes.map((type) => ({
        text: this.$t("appointment_type_" + type.toLowerCase()),
        value: type,
      }));
    },

    trainersList() {
      return [
        { id: "View all Trainers", name: this.$t("viewAllTrainers") },
        { id: "Full Time", name: this.$t("full_time") },
        { id: "Part Time", name: this.$t("part_time") },
      ];
    },

    monthsList() {
      return [
        this.$t("select_month"),
        this.$t("january"),
        this.$t("february"),
        this.$t("march"),
        this.$t("april"),
        this.$t("may"),
        this.$t("june"),
        this.$t("july"),
        this.$t("august"),
        this.$t("september"),
        this.$t("october"),
        this.$t("november"),
        this.$t("december"),
      ];
    },

    monthNames() {
      return [
        this.$t("january"),
        this.$t("february"),
        this.$t("march"),
        this.$t("april"),
        this.$t("may"),
        this.$t("june"),
        this.$t("july"),
        this.$t("august"),
        this.$t("september"),
        this.$t("october"),
        this.$t("november"),
        this.$t("december"),
      ];
    },

    daysOfWeek() {
      return [
        {
          name: "Monday",
          date: this.mondayDate,
          day: this.MondayDate,
          monthCount: this.MondayMonthCount,
        },
        {
          name: "Tuesday",
          date: this.tuesdayDate,
          day: this.TuesdayDate,
          monthCount: this.TuesdayMonthCount,
        },
        {
          name: "Wednesday",
          date: this.wednesdayDate,
          day: this.WednesdayDate,
          monthCount: this.WednesdayMonthCount,
        },
        {
          name: "Thursday",
          date: this.thursdayDate,
          day: this.ThursdayDate,
          monthCount: this.ThursdayMonthCount,
        },
        {
          name: "Friday",
          date: this.fridayDate,
          day: this.FridayDate,
          monthCount: this.FridayMonthCount,
        },
        {
          name: "Saturday",
          date: this.saturdayDate,
          day: this.SatdayDate,
          monthCount: this.SaturdayMonthCount,
        },
        {
          name: "Sunday",
          date: this.sundayDate,
          day: this.SundayDate,
          monthCount: this.SundayMonthCount,
        },
      ];
    },
  },
  methods: {
    handleStorageChange(event) {
      if (event.key === "counterValue") {
        this.counter = event.newValue;
        let text = event.newValue.split("-");
        if (text[0] == "update" || text[0] == "create") {
          this.fetchAppointments(this.monthStore);
        } else {
          this.fetchAppointments(this.monthStore);
        }
      }
    },
    getColorClass(type) {
      switch (type) {
        case "VACATION":
          return "white_traning";
        case "ABSENCE":
          return "pink_traning";
        case "TRAINING_AS_TRAINER":
          return "purple_traning";
        case "TRAINING_INITIATIVE":
          return "yellow_traning";
        case "TRAINING_DEVELOPMENT":
          return "nocolor_traning";
        case "PREPARATION_TIME":
          return "nocolor_traning";
        case "TRAVEL_TIME":
          return "lightBlue_traning";
        case "FURTHER_EDUCATION":
          return "green_traning";
        case "POSTPROCESSION_TIME":
          return "nocolor_traning";
        case "SERVICE":
          return "grey_traning";
        case "HOLIDAY":
          return "pink_traning";
        case "MISCELLANEOUS":
          return "white_traning";
        case "ROOM_BLOCKED":
          return "lightBlue_traning";
        default:
          return "";
      }
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const screenWidth = window.innerWidth;

      if (screenWidth >= 1920) {
        this.isSticky = scrollTop > 790; // Adjust this value for larger screens
      } else {
        this.isSticky = scrollTop > 570; // Default value for smaller screens
      }
    },

    // Today's date function
    todayClick() {
      this.yearFilter = null;
      this.monthFilter = null;
      this.nd = new Date();

      this.newYr = this.nd.getFullYear();
      this.monthCount = this.nd.getMonth();
      let nav = 0;
      var ndate = this.nd.getDate();
      var nday = this.nd.getDay();
      var weekOfMonth = Math.ceil((ndate - 1 - nday) / 7);
      nav = weekOfMonth;
      this.fdweek = this.nd.GetFirstDayOfWeek();
      this.getweekdt = this.nd.GetFirstDayOfWeek();
      this.startDate = new Date(this.nd.getFullYear(), 0, 1);
      // this.weekdays = Math.floor(
      //   (this.nd - this.startDate) / (24 * 60 * 60 * 1000)
      // );
      // this.weekNumber = Math.ceil(this.weekdays / 7);

      this.weekNumber = this.getISOWeekNumber(this.fdweek);

      this.updateWeekDays(formatDate, headwdateFull);
      this.updateWeekDisplay(headwdate);
      if (this.selectedYear !== this.nd.getFullYear()) {
        this.selectedYear = this.nd.getFullYear();

        this.fetchAppointments(this.nd.getMonth() + 1);
        this.monthStore = this.nd.getMonth() + 1;
      } else {
        let currentMonth = this.nd.getMonth() + 1;
        this.allObjectsMonth = this.allObjects[currentMonth];
        this.allObjectsMonthPrev = this.allObjects[currentMonth - 1];
        this.allObjectsMonthNext = this.allObjects[currentMonth + 1];
      }
      //this.updateMonthlyObjects(this.nd.getMonth());
      if (this.weekNumber == 1) {
        const prevElement = document.getElementById("prevClick");
        prevElement.classList.add("stopClick");
      } else {
        const prevElement = document.getElementById("prevClick");
        prevElement.classList.remove("stopClick");
        const nextElement = document.getElementById("nextClick");
        nextElement.classList.remove("stopClick");
      }
      this.updateWeekDates();
    },

    updateWeekDays(formatDate, headwdateFull) {
      const daysOfWeek = [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ];
      let currentDate = new Date(this.fdweek);

      daysOfWeek.forEach((day, index) => {
        this[day] = formatDate.format(currentDate);
        this[`${day}Date`] = headwdateFull.format(currentDate);
        currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
      });
    },

    updateWeekDisplay(headwdate) {
      const fweekdt = headwdate.format(this.getweekdt);
      const lweekdt = headwdate.format(
        this.getweekdt.setDate(this.getweekdt.getDate() + 6)
      );

      const [fmondt, fdaydt] = fweekdt.split(" ");
      const [lmondt, ldaydt] = lweekdt.split(" ");
      const fyeardt = fweekdt.split(",")[1];
      const lyeardt = lweekdt.split(",")[1];

      if (fyeardt === lyeardt) {
        if (fmondt === lmondt) {
          this.weekDisplay = `${fmondt} ${fdaydt} - ${ldaydt} ${fyeardt}`;
        } else {
          this.weekDisplay = `${fmondt} ${fdaydt} - ${lmondt} ${ldaydt} ${fyeardt}`;
        }
      } else {
        if (fmondt !== lmondt) {
          this.weekDisplay = `${fweekdt} - ${lweekdt}`;
        }
      }

      this.getweekdt.setDate(this.getweekdt.getDate() - 6);
    },

    updateMonthlyObjects(month) {
      this.allObjectsMonth = this.allObjects[month];
      this.allObjectsMonthPrev = this.allObjects[month - 1];
      this.allObjectsMonthNext = this.allObjects[month + 1];
      this.$forceUpdate();
    },

    //previous week funtion
    async prevWeek() {
      let that = this;
      if (that.weekNumber >= 0) {
        if (that.weekNumber == 1) {
          that.weekNumber = this.totalWeeksInLastYear;
          this.ModifyWeekNumber = true;
        } else {
          that.nav++;
          that.weekNumber--;
        }

        if (that.nav === -1) {
          that.fdweek.setDate(that.fdweek.getDate() - 5);
          that.getweekdt.setDate(that.getweekdt.getDate() - 5);
          that.inc = 0;
          that.dec = 1;
          that.cnav--;
        } else {
          that.fdweek.setDate(that.fdweek.getDate() - 7);
          that.getweekdt.setDate(that.getweekdt.getDate() - 7);
          that.nav = 4;
        }
        that.updateWeekDays(formatDate, headwdateFull);
        that.updateWeekDisplayPrev();
        const nextElement = document.getElementById("nextClick");
        nextElement.classList.remove("stopClick");
        const currentMonth = that.fdweek.getMonth() + 1;
        that.allObjectsMonth = that.allObjects[currentMonth];
        // Handle previous month (if currentMonth is 0, use 11 for December)
        that.allObjectsMonthPrev = that.allObjects[currentMonth - 1];

        // Handle next month (if currentMonth is 11, use 0 for January)
        that.allObjectsMonthNext = that.allObjects[currentMonth + 1];

        if (this.containsJan1st(this.fdweek)) {
          const prevElement = document.getElementById("prevClick");
          prevElement.classList.add("stopClick");
        } else {
          const prevElement = document.getElementById("prevClick");
          prevElement.classList.remove("stopClick");
          const nextElement = document.getElementById("nextClick");
          nextElement.classList.remove("stopClick");
        }

        this.updateWeekDates();
        this.monthCount = this.fdweek.getMonth();
      }
    },
    containsJan1st(startOfWeek) {
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      const jan1stCurrentYear = new Date(startOfWeek.getFullYear(), 0, 1);
      const jan1stNextYear = new Date(startOfWeek.getFullYear() + 1, 0, 1);
      jan1stCurrentYear.setHours(0, 0, 0, 0);
      jan1stNextYear.setHours(0, 0, 0, 0);
      startOfWeek.setHours(0, 0, 0, 0);
      endOfWeek.setHours(0, 0, 0, 0);
      return (
        (startOfWeek <= jan1stCurrentYear && jan1stCurrentYear <= endOfWeek) ||
        (startOfWeek <= jan1stNextYear && jan1stNextYear <= endOfWeek)
      );
    },

    contains31Dec(startOfWeek) {
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      const dec31stCurrentYear = new Date(startOfWeek.getFullYear(), 11, 31); // 11 is December (0-based index)
      dec31stCurrentYear.setHours(0, 0, 0, 0);
      startOfWeek.setHours(0, 0, 0, 0);
      endOfWeek.setHours(0, 0, 0, 0);
      return (
        startOfWeek <= dec31stCurrentYear && dec31stCurrentYear <= endOfWeek
      );
    },

    updateWeekDisplayPrev() {
      const fweekdt = headwdate.format(new Date(this.getweekdt));
      const lweekdt = headwdate.format(
        new Date(this.getweekdt.setDate(this.getweekdt.getDate() + 6))
      );

      const [fmondt, fdaydt] = fweekdt.split(" ");
      const [lmondt, ldaydt] = lweekdt.split(" ");
      const fyeardt = fweekdt.split(",")[1];
      const lyeardt = lweekdt.split(",")[1];

      if (fyeardt === lyeardt) {
        if (fmondt === lmondt) {
          this.weekDisplay = `${fmondt} ${fdaydt} - ${ldaydt} ${fyeardt}`;
        } else {
          this.weekDisplay = `${fmondt} ${fdaydt} - ${lmondt} ${ldaydt} ${fyeardt}`;
        }
      } else {
        this.weekDisplay = `${fweekdt} - ${lweekdt}`;
      }
      this.getweekdt.setDate(this.getweekdt.getDate() - 6);
      const monthMapping = {
        Jan: 0,
        Feb: 1,
        Mar: 2,
        Apr: 3,
        May: 4,
        Jun: 5,
        Jul: 6,
        Aug: 7,
        Sep: 8,
        Oct: 9,
        Nov: 10,
        Dec: 11,
      };
      const monthNumber = monthMapping[fmondt];
      this.firstWeek = lyeardt;
      if (fyeardt == this.prevYear) {
        this.firstDayOfPrevYear = new Date(this.prevYear, 0, 1);
        this.lastDayOfPrevYear = new Date(this.prevYear, 11, 31);
        this.startOfWeekPrevYear = this.firstDayOfPrevYear.getDay();
        this.endOfWeekPrevYear = this.lastDayOfPrevYear.getDay();
        const prevElement = document.getElementById("prevClick");
        prevElement.classList.add("stopClick");
      } else {
        const prevElement = document.getElementById("prevClick");
        prevElement.classList.remove("stopClick");
      }
    },

    updateWeekDates() {
      this.MondayDate = this.mondayDate.slice(8, 10);
      this.TuesdayDate = this.tuesdayDate.slice(8, 10);
      this.WednesdayDate = this.wednesdayDate.slice(8, 10);
      this.ThursdayDate = this.thursdayDate.slice(8, 10);
      this.FridayDate = this.fridayDate.slice(8, 10);
      this.SatdayDate = this.saturdayDate.slice(8, 10);
      this.SundayDate = this.sundayDate.slice(8, 10);
      this.MondayMonthCount = this.mondayDate.slice(5, 7) - 1;
      this.TuesdayMonthCount = this.tuesdayDate.slice(5, 7) - 1;
      this.WednesdayMonthCount = this.wednesdayDate.slice(5, 7) - 1;
      this.ThursdayMonthCount = this.thursdayDate.slice(5, 7) - 1;
      this.FridayMonthCount = this.fridayDate.slice(5, 7) - 1;
      this.SaturdayMonthCount = this.saturdayDate.slice(5, 7) - 1;
      this.SundayMonthCount = this.sundayDate.slice(5, 7) - 1;
    },

    async nextWeek() {
      let that = this;
      if (that.weekNumber >= 0) {
        if (this.ModifyWeekNumber) {
          that.weekNumber = 0;
          this.ModifyWeekNumber = false;
        }
        if (
          that.weekNumber == this.getTotalWeeksInYear(that.fdweek.getFullYear())
        ) {
          that.weekNumber = 0;
          that.ModifyWeek = true;
        }

        that.weekNumber++;
        nav++;
        if (nav == wlnav) {
          nav = 0;
          that.fdweek.setDate(that.fdweek.getDate() - 5);
          that.getweekdt.setDate(that.getweekdt.getDate() - 5);
          dec = 0;
          inc = 1;
          cnav++;
        } else {
          that.fdweek.setDate(that.fdweek.getDate() + 7);
          that.getweekdt.setDate(that.getweekdt.getDate() + 7);
        }
        that.updateWeekDays(formatDate, headwdateFull);
        that.updateWeekDisplayNext();
        const currentMonth = that.fdweek.getMonth() + 1;

        that.allObjectsMonth = that.allObjects[currentMonth];

        // Handle previous month (if currentMonth is 0, use 11 for December)
        that.allObjectsMonthPrev = that.allObjects[currentMonth - 1];

        // Handle next month (if currentMonth is 11, use 0 for January)
        that.allObjectsMonthNext = that.allObjects[currentMonth + 1];
      }
      this.updateWeekDates();
    },

    updateWeekDisplayNext() {
      const fweekdt = headwdate.format(new Date(this.getweekdt));
      const lweekdt = headwdate.format(
        new Date(this.getweekdt.setDate(this.getweekdt.getDate() + 6))
      );

      const [fmondt, fdaydt] = fweekdt.split(" ");
      const [lmondt, ldaydt] = lweekdt.split(" ");
      const fyeardt = fweekdt.split(",")[1];
      const lyeardt = lweekdt.split(",")[1];

      if (fyeardt === lyeardt) {
        if (fmondt === lmondt) {
          this.weekDisplay = `${fmondt} ${fdaydt} - ${ldaydt} ${fyeardt}`;
        } else {
          this.weekDisplay = `${fmondt} ${fdaydt} - ${lmondt} ${ldaydt} ${fyeardt}`;
        }
      } else if (fmondt !== lmondt) {
        this.weekDisplay = `${fweekdt} - ${lweekdt}`;
      }

      this.firstWeek = fyeardt;
      this.firstDayOfNextYear = new Date(this.nextYear, 0, 1);
      this.lastDayOfNextYear = new Date(this.nextYear, 11, 31);
      this.startOfWeekNextYear = this.firstDayOfNextYear.getDay();
      this.endOfWeekNextYear = this.lastDayOfNextYear.getDay();

      if (this.contains31Dec(this.fdweek)) {
        const nextElement = document.getElementById("nextClick");
        nextElement.classList.add("stopClick");
      } else {
        const nextElement = document.getElementById("nextClick");
        nextElement.classList.remove("stopClick");
      }

      // Update month-based display logic
      const monthMapping = {
        Jan: 0,
        Feb: 1,
        Mar: 2,
        Apr: 3,
        May: 4,
        Jun: 5,
        Jul: 6,
        Aug: 7,
        Sep: 8,
        Oct: 9,
        Nov: 10,
        Dec: 11,
      };
      const monthNumber = monthMapping[fmondt];
      // if (monthNumber !== undefined) {
      //   this.allObjectsMonth = this.allObjects[monthNumber];
      // }
      this.getweekdt.setDate(this.getweekdt.getDate() - 6);
      const prevElement = document.getElementById("prevClick");
      prevElement.classList.remove("stopClick");
    },

    //change year filter funtion
    changeYear() {
      this.yearCount = this.yearsList.indexOf(this.yearFilter) - 1;
      this.totalWeeksInYear = this.getTotalWeeksInYear(this.yearFilter);
      this.totalWeeksInLastYear = this.getTotalWeeksInYear(this.yearFilter - 1);
      if (this.yearCount == -1) {
        this.monthCount = this.fdweek.getMonth();
        this.newYr = this.fdweek.getFullYear();
        this.todayClick();
      } else {
        this.newYr = this.yearFilter;
        this.selectedYear = this.newYr;
        this.prevYear = this.selectedYear - 1;
        this.nd = new Date(this.newYr, this.monthCount, 1);
        var ndate = this.nd.getDate();
        var nday = this.nd.getDay();
        var weekOfMonth = Math.ceil((ndate - 1 - nday) / 7);
        nav = weekOfMonth;
        this.fdweek = this.nd.GetFirstDayOfWeek();
        this.getweekdt = this.nd.GetFirstDayOfWeek();
        var startDate = new Date(this.nd.getFullYear(), 0, 1);
        this.weekNumber = this.getISOWeekNumber(this.fdweek);
        this.updateWeekDays(formatDate, headwdateFull);
        this.updateWeekDisplay(headwdate);
        this.monthStore = this.fdweek.getMonth() + 1;
        this.fetchAppointments(this.fdweek.getMonth() + 1);
      }

      this.updateWeekDates();

      if (this.containsJan1st(this.fdweek)) {
        const prevElement = document.getElementById("prevClick");
        prevElement.classList.add("stopClick");
      } else {
        const prevElement = document.getElementById("prevClick");
        prevElement.classList.remove("stopClick");
        const nextElement = document.getElementById("nextClick");
        nextElement.classList.remove("stopClick");
      }

      this.$forceUpdate();
    },

    getTotalWeeksInYear(year) {
      const firstDay = new Date(year, 0, 1);
      const lastDay = new Date(year, 11, 31);
      const firstThursday = new Date(firstDay);
      firstThursday.setDate(
        firstThursday.getDate() + ((4 - firstThursday.getDay() + 7) % 7)
      );
      const lastThursday = new Date(lastDay);
      lastThursday.setDate(
        lastThursday.getDate() - ((lastThursday.getDay() + 3) % 7)
      );
      const oneWeek = 1000 * 60 * 60 * 24 * 7;
      const totalWeeks =
        Math.ceil((lastThursday - firstThursday) / oneWeek) + 1; // +1 to include the first week
      return totalWeeks;
    },

    getISOWeekNumber(date) {
      const dt = new Date(date);
      dt.setHours(0, 0, 0, 0);
      const dayOfWeek = (dt.getDay() + 6) % 7;
      dt.setDate(dt.getDate() - dayOfWeek + 3);
      const year = dt.getFullYear();
      const firstDayOfYear = new Date(year, 0, 4);
      const dayOfFirstWeek = (firstDayOfYear.getDay() + 6) % 7;
      const firstMonday = new Date(firstDayOfYear);
      firstMonday.setDate(firstDayOfYear.getDate() - dayOfFirstWeek);
      const daysDifference = Math.floor((dt - firstMonday) / 86400000);
      const weekNumber = Math.ceil((daysDifference + 1) / 7);
      if (weekNumber < 1) {
        return this.getISOWeekNumber(new Date(year - 1, 11, 31));
      }
      return weekNumber;
    },

    //change month filter funtion
    changeMonth() {
      this.monthCount = this.monthsList.indexOf(this.monthFilter) - 1;
      if (this.monthCount == -1) {
        this.monthCount = this.fdweek.getMonth();
        this.newYr = this.fdweek.getFullYear();
        //this.fetchAppointments(null);
        this.todayClick();
      } else {
        this.nd = new Date(this.newYr, this.monthCount, 1);
        var ndate = this.nd.getDate();
        var nday = this.nd.getDay();
        var weekOfMonth = Math.ceil((ndate - 1 - nday) / 7);
        nav = weekOfMonth;
        this.fdweek = this.nd.GetFirstDayOfWeek();
        this.getweekdt = this.nd.GetFirstDayOfWeek();
        var startDate = new Date(this.nd.getFullYear(), 0, 1);
        var days = Math.floor((this.nd - startDate) / (24 * 60 * 60 * 1000));
        this.weekNumber = this.getISOWeekNumber(this.nd);
        this.updateWeekDays(formatDate, headwdateFull);
        this.updateWeekDisplay(headwdate);
        this.monthStore = this.monthCount;
        this.fetchAppointments(this.monthCount);
        this.updateWeekDates();
        if (this.containsJan1st(this.fdweek)) {
          const prevElement = document.getElementById("prevClick");
          prevElement.classList.add("stopClick");
        } else {
          const prevElement = document.getElementById("prevClick");
          prevElement.classList.remove("stopClick");
          const nextElement = document.getElementById("nextClick");
          nextElement.classList.remove("stopClick");
        }
      }
      this.$forceUpdate();
    },

    //change trainerType filter funtion
    changeTrainerType() {
      this.trainersFilterEdited = this.trainersFilter.replaceAll(" ", "");
    },

    //new functions end

    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },

    fetchAppointments(monthParam) {
      const selectedYear = +this.selectedYear;
      let currentMon = this.currentMonth + 1; // Convert to 1-based month index

      if (this.monthCount) {
        currentMon = this.monthCount + 1; // If monthCount is defined, use it
      }

      let monthsArray = new Array(14).fill(null);
      const totalMonths = 12;

      // Step 1: Add December of the previous year at index 0
      monthsArray[0] = {
        month: totalMonths,
        year: selectedYear - 1,
      };

      // Step 2: Populate months of the current year
      for (let i = 1; i <= 12; i++) {
        monthsArray[i] = {
          month: i,
          year: selectedYear,
        };
      }

      // Step 3: Add January of the next year at index 13
      monthsArray[13] = {
        month: 1,
        year: selectedYear + 1,
      };

      // Initialize allObjects for appointments storage
      for (let i = 0; i <= 13; i++) {
        this.allObjects.push({
          month: i,
          trainerAppointments: [],
          roomAppointments: [],
        });
      }

    // Fetch trainer and room information
    this.$axios.get(`/api/calendar/fetchtrainerroom`).then((resp) => {
       let trainers = resp.data.trainers.map((trainer) => ({
            id: trainer.id,
            fullname: trainer.fullname,
            firstname: trainer.firstname,
            lastname: trainer.lastname,
            trainerLocation: trainer.trainerLocation,
            tenantLocation: trainer.tenantLocation,
            trainerType: trainer.trainerType,
        }));
          let rooms = resp.data.rooms.map((rm) => ({
            id: rm.id,
            roomLocation: rm.roomLocation,
          }));

          const req = {
            trainers: trainers,
            rooms: rooms,
          };

          // Create a helper function to make API calls and set data
          const fetchAppointmentsForMonth = (monthObj, index) => {
            const { month, year } = monthObj;
            const trainerPromise = this.$axios.post(
              `/api/calendar/trainer/${year}/${month}`,
              req
            );
            const roomPromise = this.$axios.post(
              `/api/calendar/room/${year}/${month}`,
              req
            );

            return Promise.all([trainerPromise, roomPromise])
              .then(([trainerResponse, roomResponse]) => {
                this.allObjects[index].trainerAppointments =
                  trainerResponse.data.trainerAppointments;
                this.allObjects[index].roomAppointments =
                  roomResponse.data.roomAppointments;

                // Set current, next, and previous months' objects based on `monthParam`
                if (index === monthParam) {
                  this.allObjectsMonth = this.allObjects[index];
                }
                if (index === monthParam + 1) {
                  this.allObjectsMonthNext = this.allObjects[index];
                }
                if (index === monthParam - 1) {
                  this.allObjectsMonthPrev = this.allObjects[index];
                }

                // For index 0 (current month)
                if (index === 0) {
                  this.locationsList = [
                    {
                      id: "View all Trainer locations",
                      name: this.$t("viewAllTrainerLocation"),
                    },
                    ...trainerResponse.data.trainerAppointments.map(
                      (appointment) => appointment.trainerLocation
                    ),
                  ];
                  this.roomslocationsList = [
                    {
                      id: "View all Room locations",
                      name: this.$t("viewAllRoomLocation"),
                    },
                    ...roomResponse.data.roomAppointments.map(
                      (appointment) => appointment.roomLocation
                    ),
                  ];
                }
              })
              .catch(this.onError);
          };

          // First, make API calls for the current, next, and previous months in the desired order
          let currentPromise = fetchAppointmentsForMonth(
            monthsArray[monthParam],
            monthParam
          );
          let nextPromise = fetchAppointmentsForMonth(
            monthsArray[monthParam + 1],
            monthParam + 1
          );
          if (monthParam == 0) {
            monthParam = 1;
          }
          let prevPromise = fetchAppointmentsForMonth(
            monthsArray[monthParam - 1],
            monthParam - 1
          );

          // Wait for these three to finish first
          Promise.all([currentPromise, nextPromise, prevPromise]).then(() => {
            // Then, make API calls for the remaining months in order
            const remainingPromises = monthsArray.map((monthObj, i) => {
              if (
                i !== monthParam &&
                i !== monthParam + 1 &&
                i !== monthParam - 1
              ) {
                return fetchAppointmentsForMonth(monthObj, i);
              }
            });

            Promise.all(remainingPromises).finally(() => {
              // Any final actions when all API calls are done
            });
          });
        })
        .catch(this.onError);
    },

    fetchAppointmentTypes() {
      this.$axios
        .get("/api/calendar/types")
        .then((response) => {
          const types = response.data.filter(
            (type) =>
              type !== "TRAINING_AS_PARTICIPANT" &&
              type !== "TRAINING_AS_TRAINER"
          );

          this.appointmentTypes = types;
        })
        .catch(this.onError);
    },

    fetchTrainers() {
      this.$axios
        .get("/api/user/trainer")
        .then((response) => {
          response.data.forEach((element) => {
            if (Number.isInteger(element)) {
              this.fetchSingleTrainerAndPush(element);
            } else {
              this.trainers.push(element);
            }
          });
        })
        .catch(this.onError);
    },

    fetchSingleTrainerAndPush(trainerId) {
      this.$axios
        .get("/api/user/" + trainerId)
        .then((response) => {
          this.trainers.push(response.data);
        })
        .catch(this.onError);
    },

    onFinally() {
      showLoadingCircle(false);
    },

    // Date Functions

    isNextMonth(monthToCheck, day) {
      var dt = new Date(this.selectedYear, monthToCheck, day);
      if (dt.getMonth() != monthToCheck) return true;
      return false;
    },
    getDay(date) {
      return new Date(date).getDate();
    },
    getMonth(date) {
      return new Date(date).getMonth();
    },
    getYear(date) {
      return new Date(date).getFullYear();
    },
    getAppointment(trainerAppointment, day) {
      return trainerAppointment.daysWithAppointments[day - 1].appointment;
    },
    appointmentClicked(appointmentOnDay) {
      if (
        appointmentOnDay.clickable &&
        (appointmentOnDay.type === "TRAINING_AS_TRAINER" ||
          appointmentOnDay.type === "ROOM_BLOCKED")
      ) {
        const route = this.$router.resolve({
          path:
            "/edit-training-event?trainingEventId=" +
            appointmentOnDay.reference,
        });
        window.open(route.href, "_blank");
      }
    },

    calendarDayClicked(
      reference,
      day,
      month,
      mode = "TRAINER",
      appointmentOnDay
    ) {
      if (
        !this.$rights.includes("CREATE_APPOINTMENT") ||
        this.isNextMonth(month, day)
      )
        return;

      this.clearAppointment();

      // Open Dialog and Set Type
      this.openAddDialog = true;
      this.dialog.type = mode;

      if (mode === "ROOM") {
        this.appointment.type = "ROOM_BLOCKED";
        this.appointment.reference = reference;
      }

      const selectedMonthReadable = month + 1;
      const dayString = day < 10 ? "0" + day : day;
      const monthString =
        selectedMonthReadable < 10
          ? "0" + selectedMonthReadable
          : selectedMonthReadable;
      const fullDateString = `${this.selectedYear}-${monthString}-${dayString}`;
      this.appointment.start = `${fullDateString}T00:00:00`;
      this.appointment.end = `${fullDateString}T23:59:59`;
      this.appointment.userReference = mode === "TRAINER" ? reference : null;
      this.appointment.productive = appointmentOnDay.productive;
      // Show edit Dialog
      if (appointmentOnDay) {
        const {
          id,
          start,
          end,
          userReference,
          type,
          description,
          clickable,
          reference,
          productive,
        } = appointmentOnDay;
        this.appointment = {
          id,
          start,
          end,
          userReference,
          type,
          description,
          clickable,
          reference,
          productive,
        };

        // Check if Edit Dialog shall be shown
        if (
          type === "TRAINING_AS_TRAINER" ||
          (type === "ROOM_BLOCKED" && !userReference)
        ) {
          this.openAddDialog = false;
        }
      }
    },

    clearAppointment() {
      this.appointment = {
        id: null,
        start: null,
        end: null,
        userReference: null,
        description: null,
      };
    },

    updateForAppointment(appointment, res, type) {
      var _this = this;
      let startDate = new Date(appointment.start);
      let endDate = new Date(appointment.end);
      let startMonth = startDate.getMonth() + 1; // getMonth() returns 0-11, so add 1 for 1-12
      let startYear = startDate.getFullYear();
      let endMonth = endDate.getMonth() + 1;
      let endYear = endDate.getFullYear();
      let currentMonth = startMonth;
      let currentYear = startYear;

      res.userReference = res.userReference.id;
      res.reference = res.reference;
      res.designationsMap = res.designations;
      res.clickable = false;
      res.startDayOfMonth = startDate.getDate();
      res.endDayOfMonth = endDate.getDate();
      while (
        currentYear < endYear ||
        (currentYear === endYear && currentMonth <= endMonth)
      ) {
        let daysInMonth = new Date(currentYear, currentMonth, 0).getDate();
        if (
          currentYear === startYear &&
          currentYear === endYear &&
          currentMonth === startMonth &&
          currentMonth === endMonth
        ) {
          _this.updateAppointment(
            _this.allObjects,
            currentYear,
            currentMonth,
            startDate.getDate(),
            endDate.getDate(),
            res,
            type
          );
        } else if (currentYear === startYear && currentMonth === startMonth) {
          _this.updateAppointment(
            _this.allObjects,
            currentYear,
            currentMonth,
            startDate.getDate(),
            daysInMonth,
            res,
            type
          );
        } else if (currentYear === endYear && currentMonth === endMonth) {
          _this.updateAppointment(
            _this.allObjects,
            currentYear,
            currentMonth,
            1,
            endDate.getDate(),
            res,
            type
          );
        } else {
          _this.updateAppointment(
            _this.allObjects,
            currentYear,
            currentMonth,
            1,
            daysInMonth,
            res,
            type
          );
        }
        if (currentMonth === 12) {
          currentMonth = 1;
          currentYear++;
        } else {
          currentMonth++;
        }
      }
    },
    updateAppointment(
      existingObject,
      year,
      month,
      startDay,
      endDay,
      newAppointment,
      type
    ) {
      if (!newAppointment.reference) {
        existingObject[month].trainerAppointments.forEach((trainer) => {
          if (trainer.trainer === newAppointment.userReference) {
            for (let day = startDay; day <= endDay; day++) {
              let dayString = `${year}-${month
                .toString()
                .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
              let dayObject = trainer.daysWithAppointments.find(
                (d) => d.date === dayString
              );
              if (type === "create" || type === "update") {
                dayObject.appointment = newAppointment;
              } else if (type === "delete") {
                dayObject.appointment = null;
              }
            }
          }
        });
      } else {
        existingObject[month].roomAppointments.forEach((room) => {
          if (room.room.id === newAppointment.reference) {
            for (let day = startDay; day <= endDay; day++) {
              let dayString = `${year}-${month
                .toString()
                .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
              let dayObject = room.daysWithAppointments.find(
                (d) => d.date === dayString
              );
              if (type === "create" || type === "update") {
                dayObject.appointment = newAppointment;
              } else if (type === "delete") {
                dayObject.appointment = null;
              }
            }
          }
        });
      }
    },

    saveAppointment() {
      var _this = this;
      const appointment = { ...this.appointment };

      if (
        typeof appointment.start === "string" &&
        appointment.start.length < 11
      ) {
        appointment.start += "T00:00:00";
      }
      if (typeof appointment.end === "string" && appointment.end.length < 11) {
        appointment.end += "T23:59:59";
      }

      if (appointment.id == null) {
        progressIndicator.hidden = false;
        document.getElementById("loadingCircle").classList.add("zIndex");

        this.$axios
          .post("/api/calendar/create", appointment)
          .then(function (response) {
            _this.updateForAppointment(appointment, response.data, "create");
            _this.openAddDialog = false;
            _this.$noty.success(_this.$t("appointment_saved"));
            document.getElementById("loadingCircle").classList.remove("zIndex");
          })
          .catch(this.onError)
          .finally(function () {
            progressIndicator.hidden = true;
          });
      } else {
        let resp = null;
        _this.$axios.get(`/api/calendar/${appointment.id}`).then((resp) => {
          resp = resp;
          progressIndicator.hidden = false;
          document.getElementById("loadingCircle").classList.add("zIndex");
          _this.$axios
            .put("/api/calendar/" + appointment.id, appointment)
            .then(function (response) {
              _this.updateForAppointment(resp.data, resp.data, "delete");

              _this.updateForAppointment(appointment, response.data, "update");
              _this.openAddDialog = false;
              _this.$noty.success(_this.$t("appointment_edited"));
            })
            .catch(this.onError)
            .finally(() => {
              progressIndicator.hidden = true;
              document
                .getElementById("loadingCircle")
                .classList.remove("zIndex");
            });
        });
      }
    },

    deleteAppointment() {
      var _this = this;
      this.openAddDialog = false;
      this.openDeleteDialog = false;
      const appointment = { ...this.appointment };
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      //document.getElementById("loadingCircle").classList.add("zIndex");

      this.$axios
        .delete(`/api/calendar/${appointment.id}`)
        .then((response) => {
          _this.updateForAppointment(appointment, response.data, "delete");
          this.openAddDialog = false;
          this.$noty.success(this.$t("appointment_deleted"));
        })
        .catch(this.onError)
        .finally(() => {
          progressIndicator.hidden = true;
          document.getElementById("loadingCircle").classList.remove("zIndex");
        });
    },
  },
};
</script>
